import type { KnowledgeDocument, KnowledgeGap } from '@hostesa/api-client';
import type { StatusVariant } from '@hostesa/ui';

/** Coerce an `unknown` (nullable) field to a display string, or null. */
export function asText(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return value.length > 0 ? value : null;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return null;
}

/** Coerce an `unknown` (nullable) field to a finite number, or null. */
export function asNumber(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  return null;
}

/** Map a document status to a StatusBadge variant (text label comes from i18n). */
export function documentStatusVariant(status: KnowledgeDocument['status']): StatusVariant {
  switch (status) {
    case 'approved':
      return 'success';
    case 'pending_review':
    case 'parsed':
      return 'pending';
    case 'archived':
      return 'inactive';
    case 'failed':
      return 'error';
    default:
      return 'neutral';
  }
}

/** Map a gap status to a StatusBadge variant. */
export function gapStatusVariant(status: KnowledgeGap['status']): StatusVariant {
  switch (status) {
    case 'answered':
      return 'success';
    case 'needs_answer':
      return 'warning';
    case 'dismissed':
    case 'duplicate':
      return 'inactive';
    default:
      return 'neutral';
  }
}
